export default __webpack_public_path__ + "static/media/Pass photo.178f270d.webp";